module.exports = __webpack_public_path__ + "assets/HKNova-Heavy.woff2";


//////////////////
// WEBPACK FOOTER
// ./fonts/HKNova-Heavy.woff2
// module id = 123
// module chunks = 0